import { render } from "./ProjectsBuildingGroup.vue?vue&type=template&id=519700f2&scoped=true"
import script from "./ProjectsBuildingGroup.vue?vue&type=script&lang=js"
export * from "./ProjectsBuildingGroup.vue?vue&type=script&lang=js"

import "./ProjectsBuildingGroup.vue?vue&type=style&index=0&id=519700f2&scoped=true&lang=css"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519700f2"]])

export default __exports__